module.exports = __webpack_public_path__ + "img/rankingList.268374c3.png";